module.exports = __webpack_public_path__ + "media/images/newsletter-bg-2b6ec4c1.svg";